export {useScrollWheel, type ScrollWheelProps} from '../../../src/interactions/useScrollWheel';
